import { useEffect, useRef, useState } from 'react'
import { ChatEntry } from '../store/room'
import '../css/App.css'

interface Props {
  chatLog:    ChatEntry[]
  roomCode:   string
  onSend:     (message: string) => void
  /** SEQ=10110 STEP=4 — 본인 화면만 채팅 클리어 (서버 무호출, DB 보존). 미지정 시 버튼 숨김. */
  onClear?:   () => void
  tabActive?: boolean
}

export default function ChatPanel({ chatLog, roomCode, onSend, onClear, tabActive }: Props) {
  const [input, setInput]  = useState('')
  const bottomRef          = useRef<HTMLDivElement>(null)

  // 새 메시지 시 자동 스크롤
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [chatLog])

  function handleSend() {
    const msg = input.trim()
    if (!msg) return
    onSend(msg)
    setInput('')
  }

  function handleKeyDown(e: React.KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <div className={`chat-panel${tabActive ? ' tab-active' : ''}`}>
      <div className="chat-panel-head">
        <h4 className="panel-title">채팅</h4>
        {onClear && (
          <button
            className="btn-chat-clear"
            onClick={onClear}
            title="내 화면의 채팅을 즉시 지웁니다. 상대 화면·서버 기록에는 영향 없습니다."
            aria-label="채팅 지우기"
          >
            지우기
          </button>
        )}
      </div>

      <div className="chat-list">
        {chatLog.length === 0 && (
          <p className="chat-empty muted">아직 메시지가 없습니다.</p>
        )}
        {chatLog.map((entry, idx) => (
          <div
            key={idx}
            className={entry.isSystem ? 'chat-msg system-msg' : 'chat-msg'}
          >
            {entry.isSystem ? (
              <span className="sys-text">{entry.message}</span>
            ) : (
              <>
                <span className="chat-nick">{entry.nickname}</span>
                <span className="chat-time muted">{entry.timestamp}</span>
                <p className="chat-text">{entry.message}</p>
              </>
            )}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <div className="chat-input-row">
        <input
          className="chat-input"
          type="text"
          placeholder="메시지 입력 (Enter 전송)"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={500}
        />
        <button className="btn-chat-send" onClick={handleSend}>전송</button>
      </div>
    </div>
  )
}
